/**
 * Environment configuration for Tenant UI Widget
 * Validates required environment variables and provides typed access
 */

// Helper function to validate required env vars
function getRequiredEnv(key: string): string {
  const value = import.meta.env[key];

  if (!value || value.length < 1) {
    throw new Error(`Missing required environment variable: ${key}`);
  }

  return value;
}

// Helper function for optional env vars with defaults
function getOptionalEnv(key: string, defaultValue: string): string {
  const value = import.meta.env[key];
  return value && value.length > 0 ? value : defaultValue;
}

// Validate and export environment variables
export const env = {
  // API Configuration
  API_URL: getRequiredEnv("VITE_API_URL"),

  // Sentry Configuration
  SENTRY_DSN: getOptionalEnv("VITE_SENTRY_DSN", ""),
  SENTRY_ENABLED: getOptionalEnv("VITE_SENTRY_ENABLED", "false") === "true",
  SENTRY_ENVIRONMENT: getOptionalEnv("VITE_SENTRY_ENVIRONMENT", import.meta.env.MODE || "development"),
  SENTRY_TRACES_SAMPLE_RATE: Number.parseFloat(getOptionalEnv("VITE_SENTRY_TRACES_SAMPLE_RATE", "1.0")),

  // Langfuse Configuration
  LANGFUSE_URL: getOptionalEnv("VITE_LANGFUSE_URL", ""),
  LANGFUSE_PUBLIC_KEY: getOptionalEnv("VITE_LANGFUSE_PUBLIC_KEY", ""),

  // Runtime Environment
  MODE: import.meta.env.MODE || "development",
  PROD: import.meta.env.PROD || false,
  DEV: import.meta.env.DEV || false,
} as const;

// Type export for the env object
export type Env = typeof env;
